import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/change-password',
      name: 'admin-change-password',
      component: () => import(/* webpackChunkName: "page-admin-system-management-change-password" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "修改密码"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "基础功能"
                                        },
                                        {
                                                  name: "修改密码"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
